import styled from '@emotion/styled';
import { Button } from 'react-magma-dom';
import { COLORS, FOCUS } from '../../constants';

export const StyledMoreBlocks = styled.div`
  display: flex !important;
  flex-wrap: nowrap !important;
  overflow: hidden !important;
  margin: 23px 0 27px 0 !important;
  padding-top: 10px !important;
`;

export const StyledMoreInlineBlock = styled.div`
  ${FOCUS}
  width: 167px!important;
  margin: 0px 33px 3px 0px !important;
  line-height: 60px !important;
  &:first-of-type {
    margin-left: 33px !important;
  }
  &:last-of-type {
    margin-right: 33px !important;
  }
  text-decoration: none !important;
`;

export const StyledMoreCenterBlock = styled(Button)`
  display: flex !important;
  justify-content: center !important;
  width: inherit !important;
  height: 80px !important;
  margin: 0px !important;
  margin-bottom: 10px !important;
  background-color: ${COLORS.white}!important;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15) !important;
  border: solid 1px transparent !important;

  :hover {
    border: solid 1px ${COLORS.seaBlue}!important;
  }
`;

export const StyledMoreTitle = styled.div`
  line-height: 1.25 !important;
  letter-spacing: 0.32px !important;
  color: ${COLORS.mainTextColor}!important;
  word-wrap: break-word !important;
`;

export const StyledMoreSubTitle = styled.div`
  font-size: 14px !important;
  font-weight: normal !important;
  line-height: 1.43 !important;
  letter-spacing: 0.32px !important;
  color: ${COLORS.doveGray}!important;
  word-wrap: break-word !important;
`;
